/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { forwardRef } from "react";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import Stars from "common/vue/components/Stars.react.vue";
import { cn } from "tailwind-variants";
import "./JiffyServicePreview.scss";

const JiffyServicePreview = forwardRef<HTMLAnchorElement, any>(
  (
    {
      service,
      design,
      horizontal = false,
      mixpanelEvent,
      source,
      showFromPrice = true,
      showProduct = false,
      openInNewTab = true,
      ...restProps
    },
    ref
  ) => {
    function mixpanelEvents() {
      let result = mixpanelEvent;
      if (service.additional_mixpanel_event) {
        result = [result, service.additional_mixpanel_event].join("|");
      }
      return result;
    }

    function mixpanelListeners() {
      if (service.additional_mixpanel_event) {
        return "click|click";
      }
      return "click";
    }

    function mixpanelData() {
      let data = JSON.stringify({
        service: service.service,
        catalog_number: service.catalog_number,
        page: "cart",
        business_line_promo_type: service.business_line_promo_type,
        promotion_name: service.promotion_name
      });
      if (source) {
        data = [
          data,
          JSON.stringify({
            source,
            service: service.service,
            page: "cart",
            business_line_promo_type: service.business_line_promo_type,
            promotion_name: service.promotion_name
          })
        ].join("|");
      }
      return data;
    }

    function wrapperClassNames() {
      return cn(
        `jiffy-service-preview--${service.service}`,
        !horizontal && `jiffy-service-preview--design-${design}`,
        horizontal && "jiffy-service-preview--horizontal"
      );
    }

    function isFromPriceZero() {
      return service.price_from === "$0";
    }

    function isMobileApp() {
      // @ts-expect-error TS(2339): Property 'MOBILE_APP' does not exist on type 'Wind... Remove this comment to see the full error message
      return Boolean(window.MOBILE_APP);
    }

    function reviewsCount() {
      if (service.reviews_count == null) return "0";
      const count = Number(service.reviews_count);
      return count >= 100000 ? `${Math.floor(count / 1000)}k+` : count.toLocaleString();
    }

    function openInSameTab() {
      return isMobileApp() || !openInNewTab;
    }

    return (
      <a
        {...restProps}
        ref={ref}
        className={cn(
          "jiffy-service-preview scope-4681a740",
          wrapperClassNames(),
          // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
          restProps.className
        )}
        data-mixpanel-listen={mixpanelListeners()}
        data-mixpanel-event={mixpanelEvents()}
        data-mixpanel-data={mixpanelData()}
        href={service.page_url}
        target={openInSameTab() ? "_self" : "_blank"}
        rel={openInSameTab() ? undefined : "noreferrer"}
        data-testid="jiffy-service-preview"
      >
        <img
          className="jiffy-service-preview__preview scope-4681a740"
          src={service.preview}
          alt="Service Preview"
          data-testid="preview"
        />
        <UseSvg
          className="jiffy-service-preview__icon scope-4681a740"
          icon={service.icon}
          data-testid="jiffy-service-preview-icon"
        />
        <div className="jiffy-service-preview__title scope-4681a740" data-testid="title">
          {service.title}
        </div>
        {showProduct ? (
          <div className="jiffy-service-preview__product scope-4681a740" data-testid="product-info">
            {service.brand_logo ? (
              <div className="jiffy-service-preview__product-row scope-4681a740">
                <img
                  className="jiffy-service-preview__brand-logo scope-4681a740"
                  src={service.brand_logo}
                  alt="Brand Logo"
                  data-testid="brand-logo"
                />
                <span className="scope-4681a740">|</span>
                <div
                  className="jiffy-service-preview__catalog_number scope-4681a740"
                  data-testid="catalog_number"
                >
                  {service.catalog_number}
                </div>
              </div>
            ) : null}
            {service.avg_rating ? (
              <div className="jiffy-service-preview__product-row scope-4681a740">
                <Stars
                  className="scope-4681a740"
                  stars={service.avg_rating}
                  size="XS"
                  data-testid="stars"
                />
                <div
                  className="jiffy-service-preview__reviews_count scope-4681a740"
                  data-testid="reviews_count"
                >
                  {reviewsCount()}
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
        <div className="jiffy-service-preview__prices scope-4681a740">
          {showFromPrice ? (
            <div className="jiffy-service-preview__price-from scope-4681a740">
              starting {isFromPriceZero() ? "at" : "from"}{" "}
              {!isFromPriceZero() ? (
                <s className="scope-4681a740" data-testid="price-from">
                  {service.price_from}
                </s>
              ) : null}
            </div>
          ) : null}
          <div className="jiffy-service-preview__price-per scope-4681a740">
            <div
              className="jiffy-service-preview__price-per-amount scope-4681a740"
              data-testid="price-per"
            >
              {service.price_per}
            </div>
            {service.price_per_label ? (
              <div
                className="jiffy-service-preview__price-per-label scope-4681a740"
                data-testid="price-label"
              >
                {service.price_per_label}
              </div>
            ) : null}
          </div>
        </div>
        <div className="jiffy-service-preview__cta scope-4681a740" data-testid="cta">
          {service.cta}
        </div>
      </a>
    );
  }
);

JiffyServicePreview.displayName = "JiffyServicePreview";

export default JiffyServicePreview;
